import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const TagForm = ({ mode = 'new', tag = null, onSubmit, onClose }) => {
  const [title, setTitle] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeForm = async () => {
      setIsLoading(true);
      try {
        if (tag) {
          setTitle(tag.title || '');
        } else {
          setTitle('');
        }
      } finally {
        setIsLoading(false);
      }
    };
    
    initializeForm();
  }, [tag]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    
    onSubmit({ title: title.trim() });
  };

  const isReadOnly = mode === 'view';

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1086a4] mx-auto"></div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="max-w-4xl mx-auto">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-2xl font-bold text-[#054581]">
          {mode === 'new' && 'Add New Tag'}
          {mode === 'edit' && 'Edit Tag'}
          {mode === 'view' && 'View Tag'}
        </h3>
        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 hover:text-[#1086a4] focus:outline-none transition-colors"
        >
          <X className="h-6 w-6" />
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-[#054581] mb-2">
            Tag Title <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            readOnly={isReadOnly}
            className={`w-full px-3 py-2 bg-[#f9fafb] border border-[#1086a4] rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:border-transparent transition-colors ${
              isReadOnly ? 'bg-gray-50' : ''
            }`}
            placeholder="Enter tag title"
            required
            maxLength={100}
          />
          <div className="text-right text-sm text-gray-500 mt-1">
            {title.length}/100 characters
          </div>
        </div>

        {mode === 'view' && tag?.createdBy && (
          <div>
            <label className="block text-sm font-medium text-[#054581] mb-2">
              Created By
            </label>
            <input
              type="text"
              value={tag.createdBy}
              readOnly
              className="w-full px-3 py-2 bg-gray-50 border border-[#1086a4] rounded-md text-gray-900"
            />
          </div>
        )}

        {/* Buttons */}
        <div className="flex gap-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2 px-4 border border-[#1086a4] rounded-md text-[#1086a4] font-medium hover:bg-[#f9fafb] focus:outline-none focus:ring-2 focus:ring-[#1086a4] transition-colors"
          >
            Cancel
          </button>
          {!isReadOnly && (
            <button
              type="submit"
              disabled={!title.trim()}
              className="flex-1 py-2 px-4 bg-[#1086a4] text-white rounded-md font-medium hover:bg-[#054581] focus:outline-none focus:ring-2 focus:ring-[#1086a4] transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {mode === 'new' ? 'Add Tag' : 'Save Changes'}
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default TagForm;